<template>
  <q-menu
    :mode="mode"
    :style="'float: ' + float"
    :default-active="defaultMenuActive"
    :router="router"
    :collapse="isCollapse"
    :background-color="backgroundColor"
    :text-color="foreColor"
    :active-text-color="activeTextColor"
    @select="handleSelect"
  >
    <q-menu-bar-item
      v-for="menu in menus"
      :key="menu.index"
      :mode="mode"
      :menu="menu"
    />
  </q-menu>
</template>

<script>
  import menuBarItem from "./menuBarItem";

  export default {
    name: 'QMenuBar',
    componentName: 'QMenuBar',

    components: {
      'q-menu-bar-item': menuBarItem
    },

    props: {
      float: {
        type: String,
        default: 'right'
      },
      menus: {
        type: Array,
        default: undefined
      },
      router: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'vertical'
      },
      defaultMenuActive: {
        type: String,
        default: '-1'
      },
      isCollapse: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '200px'
      },
      foreColor: {type: String, default: '#333'},
      backgroundColor: {
        type: String,
        default: '#ffffff'
      },
      activeTextColor: {
        type: String,
        default: '#B18420'
      }
    },

    data() {
      return {};
    },

    methods: {
      handleSelect(key, keyPath) {
        this.$emit('item-select', {key, keyPath})
      }
    },
  };
</script>
